import Tooltip from '@/components/Tooltip';
import BtnFlexBUilderSvg from '../../icon/btn-flex-builder.svg?tsx';
import {createOnInsertResultWithBuilderId} from '../../factory';
import styles from './index.module.scss';

export const CardGapMenuEntry = ({onClick}: {onClick: (node: any) => void}) => {
    const handleClick = () => {
        createOnInsertResultWithBuilderId('custom').then(node => {
            onClick(node);
        });
    };

    return (
        <div className={styles.container}>
            <Tooltip
                placement={'top'}
                content={'插入随心搭卡片'}
                className={styles.tooltip}
            >
                <BtnFlexBUilderSvg className={styles.icon} onClick={handleClick} />
            </Tooltip>
        </div>
    );
};
